import { RouteConfig } from 'vue-router';
import SyncMap from './components/syncMap.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/syncMap',
    name: 'syncMap',
    component: SyncMap,
    meta: { title: 'Scarica la mappa Offline'},
  },
];

export default routes;